define('viewmodels/pages/cash/methods/creditCard/UseCreditCardDepositViewModel',['underscore', 'knockout'], function(_, ko) {

    function UseCreditCardDepositViewModel(formFields, DepositAmountStep, depositPage, depositModel, Wizard) {

        var methodModel = depositModel.methodModel();

        this.wizardModel = new Wizard({
            steps: [
                new DepositAmountStep(depositModel),
                {
                    field: formFields.textField( methodModel.cvv ),
                    label: depositPage.findFieldByName('credit_card_cvv_label'),
                    type: 'numericKeypad',
                    placeholder: ko.observable('   '),
                }
            ]
        });
    }

    UseCreditCardDepositViewModel.prototype.getView = function() {
        return 'views/pages/cash/methods/wizardMethod.html';
    };

    return UseCreditCardDepositViewModel;

});

